import * as React from 'react';
import * as styles from './styles.css';

import { Header0, InlineText1 } from '@cian/ui-kit/typography';
import { Strip, StripItem } from '../../components';
import { IStripItem } from '../../../../types/hero';

export interface IHeroProps {
  stripContent: IStripItem[];
}

export function Hero({ stripContent }: IHeroProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <h1 className={styles['title']}>
          <Header0 color="white_100">
            Влияние кризиса и самоизоляции
            <br />
            на рынок недвижимости
          </Header0>
        </h1>
        <div className={styles['description']}>
          <InlineText1 color="white_100">
            Каждый день обновляем данные об изменении спроса,
            <br />
            предложения и цен на жилье
          </InlineText1>
        </div>
        <Strip>
          {stripContent.map(({ trend, title, description }, index) => {
            return <StripItem key={index} trend={trend} title={title} description={description} />;
          })}
        </Strip>
      </div>
    </div>
  );
}
